// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1XRHv","footer":"Form_footer__151KM"};